import React, { createContext, useState } from "react";
import moment from "moment";
import { STRING } from "../constant";

export const AppContext = createContext();

const initialTestState = {
  correct: 0,
  incorrect: 0,
  unanswered: 0,
  score: 0,
  test_name: "",
  test_questions_meta_data: [],
  total: 0,
  total_time: 0,
  remaining_time: 0,
  time_taken: 0,
  date: "",
  is_new_app_test: true,
};

//Rewrite of old code. removed useReducer and replaced with useState
export const AppProvider = ({ children }) => {
  // PRACTICE TEST STATE
  const [history, setHistory] = useState(initialTestState);

  // ASSESSMENT TEST STATE
  const [assessmentHistory, setAssessmentHistory] = useState(initialTestState);

  // === PRACTICE TEST FUNCTIONS ===
  function initalizePracticeTest(data) {
    setHistory({
      ...initialTestState,
      date: moment().format("MMM DD, YYYY HH:mm:ss"),
      test_name: data?.test_name ?? "",
      test_questions_meta_data: data?.test_questions_meta_data ?? [],
      total: data?.total ?? 0,
      total_time: data?.total_time ?? 0,
      remaining_time: data?.remaining_time ?? 0,
      time_taken: data?.time_taken ?? 0,
      unanswered: (data?.test_questions_meta_data ?? []).length,
    });
  }

  function onSubmitQuestion(index, item) {
    setHistory((prev) => {
      const test_questions_meta_data = [...prev.test_questions_meta_data];
      test_questions_meta_data.splice(index, 1, item);

      const correct = test_questions_meta_data.filter(
        (q) => q.response === STRING.correct_tag
      ).length;
      const incorrect = test_questions_meta_data.filter(
        (q) => q.response === STRING.incorrect_tag
      ).length;
      const unanswered = prev.total - (correct + incorrect);
      const score = prev.total ? parseInt((correct * 100) / prev.total) : 0;

      return {
        ...prev,
        test_questions_meta_data,
        correct,
        incorrect,
        unanswered,
        score,
      };
    });
  }

  function onChangeTime() {
    setHistory((prev) => {
      const remaining_time = Math.max(prev.remaining_time - 1, 0);
      const time_taken = prev.total_time - remaining_time;
      return {
        ...prev,
        remaining_time,
        time_taken,
      };
    });
  }

  function resetPracticeTest() {
    setHistory(initialTestState);
  }

  // === ASSESSMENT TEST FUNCTIONS ===
  function initalizeAssessmentTest(data) {
    setAssessmentHistory({
      ...initialTestState,
      date: moment().format("MMM DD, YYYY HH:mm:ss"),
      test_name: data?.test_name ?? "",
      test_questions_meta_data: data?.test_questions_meta_data ?? [],
      total: data?.total ?? 0,
      total_time: data?.total_time ?? 0,
      remaining_time: data?.remaining_time ?? 0,
      time_taken: data?.time_taken ?? 0,
      unanswered: (data?.test_questions_meta_data ?? []).length,
    });
  }

  function onSubmitAssessmentQuestion(index, item) {
    setAssessmentHistory((prev) => {
      const test_questions_meta_data = [...prev.test_questions_meta_data];
      test_questions_meta_data.splice(index, 1, item);

      const correct = test_questions_meta_data.filter(
        (q) => q.response === STRING.correct_tag
      ).length;
      const incorrect = test_questions_meta_data.filter(
        (q) => q.response === STRING.incorrect_tag
      ).length;
      const unanswered = prev.total - (correct + incorrect);
      const score = prev.total ? parseInt((correct * 100) / prev.total) : 0;

      return {
        ...prev,
        test_questions_meta_data,
        correct,
        incorrect,
        unanswered,
        score,
      };
    });
  }

  function onChangeAssessmentTime() {
    setAssessmentHistory((prev) => {
      const remaining_time = Math.max(prev.remaining_time - 1, 0);
      const time_taken = prev.total_time - remaining_time;
      return {
        ...prev,
        remaining_time,
        time_taken,
      };
    });
  }

  function resetAssessmentTest() {
    setAssessmentHistory(initialTestState);
  }

  return (
    <AppContext.Provider
      value={{
        // Practice test
        history,
        initalizePracticeTest,
        onSubmitQuestion,
        onChangeTime,
        resetPracticeTest,

        // Assessment test
        assessmentHistory,
        initalizeAssessmentTest,
        onSubmitAssessmentQuestion,
        onChangeAssessmentTime,
        resetAssessmentTest,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
